// src/components/SectionHeading.tsx
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  accent?: string;
  desc?: string;
  center?: boolean;
}

export default function SectionHeading({ eyebrow, title, accent, desc, center = false }: SectionHeadingProps) {
  return (
    <div style={{ textAlign: center ? "center" : "left", marginBottom: "2rem" }}>
      {eyebrow && (
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8,
          fontSize: 11, fontFamily: "var(--mono)", color: "var(--purple4)",
          letterSpacing: ".12em", textTransform: "uppercase", marginBottom: 12,
        }}>
          <span style={{ width: 24, height: 1, background: "var(--purple4)", display: "inline-block" }} />
          {eyebrow}
        </div>
      )}
      <h2 style={{
        fontFamily: "var(--display)", fontSize: "clamp(28px,3.5vw,42px)",
        fontWeight: 700, lineHeight: 1.1, color: "#fff", marginBottom: desc ? 12 : 0,
      }}>
        {title}{" "}
        {accent && <span style={{ color: "var(--purple3)" }}>{accent}</span>}
      </h2>
      {desc && (
        <p style={{ fontSize: 15, color: "var(--muted)", lineHeight: 1.7, maxWidth: center ? 540 : "none", margin: center ? "0 auto" : undefined }}>
          {desc}
        </p>
      )}
    </div>
  );
}
